module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "proposedIssuanceLicence"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": _vm.title,
      "large": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "licenceForm"
    }
  }, [_c('alert', {
    attrs: {
      "show": _vm.showError,
      "type": "danger"
    },
    on: {
      "update:show": function($event) {
        _vm.showError = $event
      }
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorString))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.applicationSelectedActivitiesForPurposes), function(a, index) {
    return _c('div', {
      key: ("a_" + index),
      staticClass: "col-sm-12"
    }, [(_vm.canAssignOfficerFor(a.licence_activity)) ? _c('div', [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selected_activity_tab_id === a.licence_activity),
        expression: "selected_activity_tab_id === a.licence_activity"
      }]
    }, _vm._l((a.proposed_purposes), function(p, p_idx) {
      return _c('div', {
        key: ("p_" + p_idx)
      }, [_c('div', {
        staticClass: "panel panel-primary"
      }, [_c('div', {
        staticClass: "panel-heading"
      }, [_c('h4', {
        staticClass: "panel-title"
      }, [_vm._v(_vm._s(p.purpose.short_name) + "\n                                                        "), _c('a', {
        staticClass: "panelClicker",
        attrs: {
          "href": "#" + p_idx + index + _vm.purposeBody,
          "data-toggle": "collapse",
          "data-parent": "#userInfo",
          "expanded": "true",
          "aria-controls": _vm.purposeBody
        }
      }, [_c('span', {
        staticClass: "glyphicon glyphicon-chevron-down pull-right "
      })])])]), _vm._v(" "), _c('div', {
        staticClass: "panel-body panel-collapse collapse",
        attrs: {
          "id": "" + p_idx + index + _vm.purposeBody
        }
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-sm-12"
      }, [_c('div', {
        staticClass: "col-sm-3"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.getPickedPurpose(p.purpose.id).isProposed),
          expression: "getPickedPurpose(p.purpose.id).isProposed"
        }],
        attrs: {
          "type": "radio",
          "id": p.purpose.id
        },
        domProps: {
          "value": true,
          "checked": _vm._q(_vm.getPickedPurpose(p.purpose.id).isProposed, true)
        },
        on: {
          "change": function($event) {
            _vm.$set(_vm.getPickedPurpose(p.purpose.id), "isProposed", true)
          }
        }
      }), _vm._v(" Issue  \n                                                                "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.getPickedPurpose(p.purpose.id).isProposed),
          expression: "getPickedPurpose(p.purpose.id).isProposed"
        }],
        attrs: {
          "type": "radio",
          "id": p.purpose.id
        },
        domProps: {
          "value": false,
          "checked": _vm._q(_vm.getPickedPurpose(p.purpose.id).isProposed, false)
        },
        on: {
          "change": function($event) {
            _vm.$set(_vm.getPickedPurpose(p.purpose.id), "isProposed", false)
          }
        }
      }), _vm._v(" Decline  \n                                                            ")]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-3"
      }, [(_vm.getPickedPurpose(p.purpose.id).isProposed) ? _c('div', {
        ref: ("start_date_" + (p.id)),
        refInFor: true,
        staticClass: "input-group date",
        staticStyle: {
          "width": "100%"
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (p.proposed_start_date),
          expression: "p.proposed_start_date"
        }],
        staticClass: "form-control",
        attrs: {
          "readonly": !_vm.canEditLicenceDates && p.proposed_start_date,
          "type": "text",
          "name": ("start_date_" + (p.id)),
          "placeholder": "DD/MM/YYYY"
        },
        domProps: {
          "value": (p.proposed_start_date)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(p, "proposed_start_date", $event.target.value)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "input-group-addon"
      }, [_c('span', {
        staticClass: "glyphicon glyphicon-calendar"
      })])]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-3"
      }, [(_vm.getPickedPurpose(p.purpose.id).isProposed) ? _c('div', {
        ref: ("end_date_" + (p.id)),
        refInFor: true,
        staticClass: "input-group date",
        staticStyle: {
          "width": "100%"
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (p.proposed_end_date),
          expression: "p.proposed_end_date"
        }],
        staticClass: "form-control",
        attrs: {
          "readonly": !_vm.canEditLicenceDates && p.proposed_end_date,
          "type": "text",
          "name": ("end_date_" + (p.id)),
          "placeholder": "DD/MM/YYYY"
        },
        domProps: {
          "value": (p.proposed_end_date)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(p, "proposed_end_date", $event.target.value)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "input-group-addon"
      }, [_c('span', {
        staticClass: "glyphicon glyphicon-calendar"
      })])]) : _vm._e()])]), _vm._v(" "), (_vm.getPickedPurpose(p.purpose.id).isProposed) ? _c('div', {
        staticClass: "col-sm-12"
      }, [_c('div', {
        staticClass: "col-sm-3"
      }, [_c('label', {
        staticClass: "control-label pull-left",
        attrs: {
          "for": "Name"
        }
      }, [_vm._v("Additional Fee")])]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-6"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (p.additional_fee),
          expression: "p.additional_fee"
        }],
        ref: "licence_fee",
        refInFor: true,
        staticClass: "form-control",
        staticStyle: {
          "width": "20%"
        },
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (p.additional_fee)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(p, "additional_fee", $event.target.value)
          }
        }
      })])]) : _vm._e(), _vm._v(" "), (_vm.getPickedPurpose(p.purpose.id).isProposed) ? _c('div', {
        staticClass: "col-sm-12"
      }, [_c('div', {
        staticClass: "col-sm-3"
      }, [_c('label', {
        staticClass: "control-label pull-left",
        attrs: {
          "for": "Name"
        }
      }, [_vm._v("Fee Description 1")])]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-6"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (p.additional_fee_text),
          expression: "p.additional_fee_text"
        }],
        ref: "licence_fee_text",
        refInFor: true,
        staticClass: "form-control",
        staticStyle: {
          "width": "70%"
        },
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (p.additional_fee_text)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(p, "additional_fee_text", $event.target.value)
          }
        }
      })])]) : _vm._e(), _vm._v(" "), _vm._l((p.purpose_species_json), function(free_text, pt_idx) {
        return _c('div', {
          key: ("pt_" + pt_idx)
        }, [_c('br'), _vm._v(" "), _c('div', {
          staticClass: "col-sm-12"
        }, [_c('div', {
          staticClass: "col-sm-3"
        }, [_c('label', {
          staticClass: "control-label pull-left",
          attrs: {
            "for": "Name"
          }
        }, [_vm._v("Details")]), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (free_text.is_additional_info),
            expression: "free_text.is_additional_info"
          }]
        }, [_c('br'), _c('br'), _vm._v(" "), _c('input', {
          attrs: {
            "type": "checkbox",
            "checked": "",
            "disabled": ""
          }
        }), _vm._v(" "), _c('label', [_vm._v("Is additional info")])])]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-9"
        }, [_c('ckeditor', {
          ref: "ap_text_detail",
          refInFor: true,
          attrs: {
            "config": _vm.editorConfig
          },
          model: {
            value: (free_text.details),
            callback: function($$v) {
              _vm.$set(free_text, "details", $$v)
            },
            expression: "free_text.details"
          }
        })], 1)])])
      })], 2)])])])
    }), 0)]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Details for Applicant")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propose_issue.reason),
      expression: "propose_issue.reason"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "name": "licence_details"
    },
    domProps: {
      "value": (_vm.propose_issue.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propose_issue, "reason", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Copy email")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propose_issue.cc_email),
      expression: "propose_issue.cc_email"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "type": "text",
      "name": "licence_cc"
    },
    domProps: {
      "value": (_vm.propose_issue.cc_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propose_issue, "cc_email", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Documents for Applicant")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('filefield', {
    ref: "issuance_documents",
    attrs: {
      "name": "issuance-documents",
      "isRepeatable": true,
      "documentActionUrl": "temporary_document"
    },
    on: {
      "update-temp-doc-coll-id": _vm.setTemporaryIssuanceDocumentsCollectionId
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Details for Approver")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propose_issue.approver_detail),
      expression: "propose_issue.approver_detail"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "name": "licence_details"
    },
    domProps: {
      "value": (_vm.propose_issue.approver_detail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propose_issue, "approver_detail", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Documents for Approver")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('filefield', {
    ref: "comms_log_file",
    attrs: {
      "name": "comms-log-file",
      "isRepeatable": true,
      "documentActionUrl": "temporary_document"
    },
    on: {
      "update-temp-doc-coll-id": _vm.setTemporaryEmailCollectionId
    }
  })], 1)])]), _vm._v(" "), _vm._l((_vm.checkedActivities), function(a, idx) {
    return _c('div', [_c('div', {
      staticClass: "form-group"
    }), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "row"
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "row"
    })])])
  })], 2)], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.issuingLicence) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": ""
    },
    on: {
      "click": _vm.ok
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("Proposing Issue")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("Propose Issue")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e088cc8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/internal/applications/proposed_issuance.vue
// module id = 948
// module chunks = 0